interface CurrencyFieldProps {
  label: string;
  value: number | '';
  onChange: (value: number | '') => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
}

export default function CurrencyField({
  label,
  value,
  onChange,
  required = false,
  placeholder,
  error,
}: CurrencyFieldProps) {
  const formatCurrency = (val: number | '') => {
    if (val === '' || val === null || val === undefined) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(val);
  };

  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">$</span>
        <input
          type="number"
          value={value === '' || value === null || value === undefined ? '' : value}
          onChange={(e) => {
            const val = e.target.value;
            onChange(val === '' ? '' : Number(val));
          }}
          placeholder={placeholder}
          min={0}
          step={1000}
          className={`w-full bg-[#1a1f3a] border rounded-lg pl-8 pr-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 ${
            error ? 'border-red-500/50' : 'border-[#2d1b3d]'
          }`}
        />
      </div>
      {value !== '' && value !== null && value !== undefined && (
        <div className="text-xs text-gray-500 mt-1">{formatCurrency(value)}</div>
      )}
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



